import { createContext, useContext } from "react";

type ResponseEditorContextValue = {
  disabledDropzoneIds: number[];
};

export const ResponseEditorContext = createContext<ResponseEditorContextValue>({ disabledDropzoneIds: [] });

export const useResponseEditorContext = () => {
  const context = useContext(ResponseEditorContext);
  if (!context) {
    throw new Error(`Missing ResponseEditorContextProvider in component tree.`);
  }
  return context;
};
